import { useEffect } from "react";

/**
 * Adds .visible to elements with .reveal once they enter the viewport.
 * Keeps it minimal — CSS handles the actual animation.
 */
export const useScrollReveal = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const els = document.querySelectorAll(".reveal:not(.visible)");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
};
